import StrictObj from './strict-obj'
import { has, isArray } from 'lodash-es'

const FLAG_INIT = '__init__'
const FLAG_DONE = '__done__'
const FLAG_FAIL = '__fail__'
const FLAG_DENY = '__deny__'

export default StrictObj({
  clear,
  init,

  done,
  fail,
  deny,
  forceDeny,

  isInit,
  isDone,
  isFail,
  isDeny,
  isProcessed,

  _hasFlag,
  _hasInitFlag
})

function _hasFlag(post) {
  return has(post, 'flag')
}

function _hasInitFlag(post) {
  return _hasFlag(post) && post.flag === FLAG_INIT
}

function clear(post) {
  if (isArray(post)) {
    post.forEach(clear)
  } else {
    delete post.flag
  }
  return post
}

function init(post) {
  if (isArray(post)) {
    post.forEach(init)
  } else {
    post.flag = FLAG_INIT
  }
  return post
}

function done(post) {
  if (isArray(post)) {
    post.forEach(done)
  } else {
    post.flag = FLAG_DONE
  }
  return post
}

function fail(post) {
  if (isArray(post)) {
    post.forEach(fail)
  } else {
    post.flag = FLAG_FAIL
  }
  return post
}

function deny(post) {
  if (isArray(post)) {
    post.forEach(deny)
  } else {
    post.flag = FLAG_DENY
  }
  return post
}

function forceDeny(post) {
  if (isArray(post)) {
    post.forEach(forceDeny)
  } else {
    post.flag = FLAG_DENY
  }
  return post
}

function isInit(post) {
  return post.flag === FLAG_INIT
}

function isDone(post) {
  return post.flag === FLAG_DONE
}

function isFail(post) {
  return post.flag === FLAG_FAIL
}

function isDeny(post) {
  return post.flag === FLAG_DENY
}

function isProcessed(post) {
  return post.flag !== FLAG_INIT
}
